/* eslint-disable no-console */
export default function awaitYandexMetrica(customYmId) {
    const timerId = setInterval(() => {
        if (window[`ym${customYmId}`] !== undefined) {
            window.ym = window[`ym${customYmId}`];
            clearInterval(timerId);
        }
    }, 100);

    setTimeout(() => {
        if (window.ym === undefined) {
            console.error(`Timeout get ym${customYmId}(возможно неверно указан customYmId)`);
        }
        clearInterval(timerId);
    }, 5000);
}
